<template>
    <div class="section-header">
        <div class="title-container">
            <slot>{{ title }}</slot>
        </div>
        <div class="btn-container">
            <slot name="action"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SySectionHeader',
    props: {
        /**
         * 标题
         */
        title: {
            type: String,
            default: '详情页'
        },
        /**
         * 显示返回按钮
         */
        showBack: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        /**
         * 返回事件
         */
        handleClick() {
            this.$emit('back');
        }
    }
};
</script>

<style lang="scss" scoped>
.section-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 32px;
    margin: 16px 0;
    padding: 0 24px;

    .title-container {
        display: flex;
        font-weight: bold;
        font-size: 14px;

        &::before {
            width: 4px;
            height: 16px;
            margin-right: 20px;
            background-color: #1890ff;
            content: '';
        }
    }

    .btn-container {
        a {
            color: #1890ff;
            text-decoration: none;
        }

        .el-button + .el-button {
            margin-left: 20px;
        }
    }
}
</style>
